import React from 'react';

import getDataFrameWarnings, {DataFrameWarningOptions} from 'data-frames/util/getDataFrameWarnings';
import {InlineBannerProps, InlineBannerType} from 'ui-library/banners/InlineBanner';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';

export interface DataFrameRowsBannerProps extends DataFrameWarningOptions {
  /**
   * Whether the user has an option to download the complete data.
   *
   * @default true
   */
  canDownloadCompleteData?: boolean;
}

/**
 * Banner to alert the user when a data frame has more rows or columns than are currently being displayed.
 *
 * If the entire data frame is available, will return null.
 */
export default function DataFrameWarningBanner({
  canDownloadCompleteData = true,
  ...dataFrameWarningOptions
}: DataFrameRowsBannerProps): JSX.Element | null {
  const messages: Array<InlineBannerProps> = getDataFrameWarnings(dataFrameWarningOptions).map((warning) => ({
    bannerType: InlineBannerType.WARNING,
    text: warning,
    supportingInfo: canDownloadCompleteData ? 'Download to view the complete data.' : null,
  }));

  return messages.length > 0 ? <InlineBannerStack messages={messages} /> : null;
}
